import React from 'react';
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';

const Wrapper = styled.div`
  
`;

const TypoGraphySkeleton = function TypoGraphySkeleton() {
  return (
    <Wrapper>
      <SkeletonCustom diameter="20px" margin="0px 0px 30px 0px" width="50%" height="35px" />
      <SkeletonCustom diameter="20px" margin="0px 0px 5px 0px" width="90%" height="12px" />
      <SkeletonCustom diameter="20px" margin="0px 0px 5px 0px" width="80%" height="12px" />
      <SkeletonCustom diameter="20px" margin="0px 0px 5px 0px" width="70%" height="12px" />
      <SkeletonCustom diameter="20px" margin="0px 0px 5px 0px" width="60%" height="12px" />
      <SkeletonCustom diameter="20px" margin="0px 0px 5px 0px" width="50%" height="12px" />
    </Wrapper>
  );
};

export default TypoGraphySkeleton;
